export const getRayIds = (rayIds) => {
  return rayIds
}
